export const ADMIN_AUDIT_SEARCH_REQUEST_DATA =
  'auditSearch/ADMIN_AUDIT_SEARCH_REQUEST_DATA';
export const ADMIN_AUDIT_SEARCH_RECEIVE_DATA =
  'auditSearch/ADMIN_AUDIT_SEARCH_RECEIVE_DATA';
